import React from "react";
import { GullComposer, GullMessages, useThread, GullAvatar } from "../Gull";
import { useLoad } from "../ui";

export function GullPanel({ pid, onChanged }: { pid: string; onChanged: () => void }) {
  const { data } = useLoad<any[]>(`/gull/threads?programme_id=${pid}`);
  const latest = data && data.length ? data[0].id : null;
  const th = useThread(latest, pid);
  return (
    <section className="gull-panel" data-testid="gull-panel">
      <div className="gull-head"><GullAvatar size={22} /><div><b>Ask Gull about this programme</b><span className="tiny muted"> · what changed, what blocks a date, who needs to do what · answers come from the shared evaluation</span></div></div>
      <GullMessages thread={th.thread} pid={pid} onPinned={onChanged} />
      <GullComposer compact pid={pid} say={th.say} busy={th.busy} placeholder="What blocks the service start? Move the forecast to 2026-11-12. Prepare the pack for Financier A." onSent={onChanged} />
    </section>
  );
}
